import Vue from 'vue'
import VueRouter from 'vue-router'
import {
  Spin
} from 'view-design'
import util from '@/libs/util';
import Setting from '@/setting';

Vue.use(VueRouter)

const routes = [{
  path: "/login",
  name: "login",
  meta: {
    title: "登录"
  },
  component: () => import("@/views/account/login/index.vue")
},
{
  path: "/register",
  name: "register",
  meta: {
    title: "注册"
  },
  component: () => import("@/views/account/register/index.vue")
},
{
  path: "/forgetCipher",
  name: "forgetCipher",
  meta: {
    title: "忘记密码"
  },
  component: () => import("@/views/account/forgetCipher/index.vue")
},
{
  path: "/404",
  name: "404",
  meta: {
    title: "无法访问"
  },
  component: () => import("@/views/404/index.vue")
},
{
  path: "/",
  name: "main",
  redirect: "/home",
  component: () => import("@/components/main/index.vue"),
  children: [{
    path: "/home",
    name: "home",
    component: () => import("@/views/home/index.vue")
  },
  {
    path: "/article/:code",
    name: "article",
    component: () => import("@/views/article/index.vue")
  },
  {
    path: "/declare/:id",
    name: "declare",
    component: () => import("@/views/declare/index.vue")
  },
  {
    path: "/declares/:id",
    name: "declares",
    component: () => import("@/views/declare2/index.vue")
  },
  {
    path: "/speedQuery/:code",
    name: "speedQuery",
    component: () => import("@/views/speed/index.vue")
  },
  {
    path: "/speedDetails/:code",
    name: "speedDetails",
    component: () => import("@/views/speed/speedDetails.vue")
  },
  {
    path: "/sczykhDetail/:code",
    name: "sczykhDetail",
    component: () => import("@/views/speed/sczykhDetail.vue")
  }
  ]
}
]

const router = new VueRouter({
  routes,
  mode: Setting.routerMode,
})

//白名单路由
const AUTH_WHITE_LIST = ['/login', '/404', '/register', '/forgetCipher'];
router.beforeEach((to, from, next) => {
  Spin.show({
    render: (h) => {
      return h('div', [
        h('Icon', {
          'class': 'demo-spin-icon-load',
          props: {
            type: 'ios-loading',
            size: 24
          }
        }),
        h('div', '页面跳转中...')
      ])
    }
  });

  let token = util.cookies.get('token');
  //判断是否登录(有token表示已登录)
  if (!token) {
    //在白名单中就继续正常走
    if (AUTH_WHITE_LIST.indexOf(to.path) !== -1) {
      next();
    } else if (to.matched.length === 0) {
      // 未知页面调错误也
      next('/404')
    } else {
      // 没有登陆，不在白名单里，重定向到登陆页
      // next(`/login?redirect=${to.path}`)
      next('/login')
      Spin.hide()
    }
  } else {
    /* 有token情况*/
    if (to.path === "/login") {
      next({
        path: "/"
      });
      Spin.hide();
    } else {
      next();
    }
  }
});

router.afterEach(() => {
  Spin.hide();
  window.scrollTo(0, 0)
})

export default router